import { useCallback, useState } from 'react';

export const useToggleModal = () => {
  const [open, setOpen] = useState(false);

  const openModal = useCallback(() => {
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setOpen(false);
  }, []);

  const toggleModal = useCallback(() => {
    setOpen((open) => !open);
  }, []);

  return {
    open,
    openModal,
    closeModal,
    toggleModal,
  };
};

export default useToggleModal;
